export default __webpack_public_path__ + "static/media/Scholar's Straps of the Moon.10670a8d.jpg";